import { useState } from "react";
import { useTranslation } from "react-i18next";

// Css
import { Alert } from "react-bootstrap";
//import "../css/login.css";

// Services
import { validateEmail } from "../../../Services/string.service";
import { authService } from "../../../Services/auth.service";

// Hooks
import posthog from "../../../Services/posthog";

export default function Remember(props) {
  const { t } = useTranslation();
  const [alertShow, setAlertShow] = useState({ show: false, message: "" });
  const [rememberPayload, setRememberPayload] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isSended, setIsSended] = useState(false);
  //const [buttonLoading, setButtonLoading] = useState(false);
  const handleField = (field, value) => {
    rememberPayload[field] = value;
    setRememberPayload(rememberPayload);
    setAlertShow({ show: false, message: "" });
  };

  const validate = () => {
    if (rememberPayload) {
      if (!rememberPayload["email"]) {
        setAlertShow({ show: true, message: t("ERRORS.EMAIL_FORMAT") });
        return false;
      }
      if (rememberPayload["email"]) {
        if (!validateEmail(rememberPayload["email"])) {
          setAlertShow({ show: true, message: t("ERRORS.EMAIL_FORMAT") });
          return false;
        }
      }
      return true;
    }
    console.warn("Nenhum dado Fornecido para o Lembrar senha!");
    return false;
  };

  const sendRemember = async () => {
    
    if (validate()) {
      try {
        setButtonLoading(true)
        const payload = {
          email: rememberPayload["email"],
        };

        const response = await authService.recoverPass(payload);
        if (response) {
          posthog.capture("password recovery requested");
          setAlertShow({
            show: true,
            message:
              typeof response === "string"
                ? response
                : t("LOGIN.REMINDER_SENT", { email: payload.email }),
          });
          setIsSended(true);
        } else {
          setAlertShow({
            show: true,
            message: t("ERRORS.SEND_RECOVERY_MAILS"),
          });
        }
      } catch (error) {
        setAlertShow({
          show: true,
          message: t("ERRORS.SEND_RECOVERY_MAILS"),
        });
        console.error(error);
      } finally {
        setButtonLoading(false)
        props.onLoading(false);
      }
    }
    props.onLoading(false);
  };

  const returnToLogin = async () => {
    props.showAccessSection(true);
  };

  return (
    <>
      <span className='login100-form-title p-b-43'>{t("LOGIN.PASSWORD_REMINDER")}</span>

      <Alert
        variant='warning'
        style={alertShow.show ? { display: "block" } : { display: "none" }}>
        <strong>{t("COMMON.ATTENTION")}</strong>
        <p dangerouslySetInnerHTML={{
          __html: alertShow.message,
        }}></p>

      </Alert>

  { !isSended && 
      <div
        className='wrap-input100 validate-input'
        onClick={() => document.getElementById("rememberEmail")?.focus()}
      >
        <input
          className={`input100 ${rememberPayload.email ? "has-val" : ""}`}
          type='email'
          id='rememberEmail'
          name='accessEmail'
          autoComplete='off'
          onChange={(e) => handleField("email", e.target.value)}
        />
        <span className='focus-input100'></span>
        <label htmlFor='rememberEmail' className='label-input100'>
          {t("LOGIN.EMAIL")}
        </label>
      </div>
        }

 { !isSended && 
      <div className='flex-sb-m w-full p-t-3 p-b-32 p-2'>
        <div onClick={returnToLogin} style={{ cursor: "pointer" }}>
          {t("LOGIN.BACK")}{" "}
        </div>
      </div>
      }

      <div className='container-login100-form-btn'>
        { !isSended ?
          <button
          className='login100-form-btn'
          type='button'
          onClick={sendRemember}
          disabled={buttonLoading}>
              {buttonLoading && (
              <div
                className="spinner-border"
                style={{ marginRight: "10px" }}
              >
                <span className="visually-hidden">{t("LOGIN.LOADING_TEXT")}</span>
              </div>
            )}
          {buttonLoading ? t("LOGIN.SENDING") : t("LOGIN.REMEMBER_PASSWORD")}
        </button> : 
          <button
          className='login100-form-btn'
          type='button'
          onClick={returnToLogin} 
          >
          {t("LOGIN.BACK")}
        </button>  
          }
      </div>
    </>
  );
}
